import $ from 'jquery';
window.$ = window.jQuery = $;
jQuery = $;
import select2 from 'select2';

$(function() {
    $('.select2').select2();
});